import { isEmpty } from '@myap/ui-library'
import DINameAddress from '../DINameAddress'
import { OpenNewWindow } from '../../_common'

function NoLongerAvailable({ scoreSendData }) {
  const hasSelectedDI = !isEmpty(scoreSendData?.diCode)
  return (
    <>
      <h1 className="cb-margin-bottom-16 cb-font-weight-regular">Sorry the deadline has passed.</h1>
      <p>
        Each year you take AP Exams, you can have your AP score report sent for free to one
        recipient (a college, university, or scholarship organization).
      </p>
      {hasSelectedDI ? (
        <>
          <p>
            The institution you have selected for this year is listed below. The deadline to change
            the recipient for this year&#39;s free score send has passed.
          </p>
          <p>
            If you would like to send score reports to additional colleges, universities, or
            scholarship programs, you can do so for a fee. Find out more about{' '}
            <OpenNewWindow url="https://apscore.collegeboard.org/scores/score-reporting">
              AP score reporting services<span className="sr-only"> (Opens in a new window)</span>
            </OpenNewWindow>
            .
          </p>
          <DINameAddress org={scoreSendData.org} />
        </>
      ) : (
        <p>
          <em>No free score send selected for this year.</em>
        </p>
      )}
    </>
  )
}

export default NoLongerAvailable
